import React, { useState } from "react";
import { Schema } from "@comparaonline/products-schema";

import { Container } from "./Container";
import { FormSteps } from "./FormSteps";
import { ReviewFormStep } from "./types";

interface ReviewFormProps {
  product: Schema.ProductListProduct;
}

export const ReviewForm: React.FC<ReviewFormProps> = ({ product }) => {
  const [state, setState] = useState<ReviewFormStep>(ReviewFormStep.Start);
  return (
    <Container>
      <FormSteps step={state} changeStep={setState} product={product} />
    </Container>
  );
};
